import React, { useState } from 'react';
import clsx from 'clsx';
//Sorting Component
const SortingComponent = ({
  items,
  isOpen,
  t,
  selectSortValue,
  setSelectSortValue,
  selectSortText,
  setSelectSortText,
  setAllFilters,
  mobileView,
}) => {
  const icon_pagination_angleDown =
    '/-/jssmedia/Project/FAB2/shared/images/icon_pagination-angledown.svg';
  const icon_sortBlue = '/-/media/Project/FAB2/shared/images/icon_sort-blue.svg';

  const [dropdownOpened, setDropdownOpened] = useState(isOpen);
  //methods
  const openCloseDropdown = () => {
    setDropdownOpened((prev) => !prev);
  };
  const setSortItemSelected = (e, sortValue, sortText) => {
    setSelectSortValue(sortValue);
    setSelectSortText(sortText);
    setAllFilters((prev) => {
      return {
        ...prev,
        sortBy: sortValue,
      };
    });
  };
  return (
    <div
      className={clsx(
        'sortBy-sorting flex-it flex-align-items-center',
        dropdownOpened ? 'open' : ''
      )}
      onClick={openCloseDropdown}
    >
      {!mobileView && (
        <>
          <div className="sortBy-text desktop">{t('sortBy')}</div>
          <div className="sortBy-selected-option">
            <div className="sortBy-selected-text font-sorting-text">{selectSortText}</div>
            <span className="sortBy-arrow">
              <img src={icon_pagination_angleDown} />
            </span>
          </div>
        </>
      )}

      {mobileView && (
        <>
          <div className="arrow-top"></div>
          <div className="mobile icon_sorting flex-it flex-align-item-center flex-justify-center">
            <img src={icon_sortBlue} />
          </div>
        </>
      )}

      <div className={clsx('sortBy-dropdown', items?.length > 4 ? 'withOverflow' : '')}>
        <div className="wrap-overflow">
          <div className="overflow">
            <div className="sortBy-dropdown-options">
              {items?.map((item, index) => {
                return (
                  <div
                    className={clsx(
                      'sortBy-dropdown-option flex-it flex-align-item-center font-sorting-text',
                      selectSortValue === item?.fields?.DropdownValue?.value
                        ? 'selected-sorting'
                        : ''
                    )}
                    key={index}
                    onClick={($event) =>
                      setSortItemSelected(
                        $event,
                        item?.fields?.DropdownValue?.value,
                        item?.fields?.DropdownText?.value
                      )
                    }
                  >
                    <input type="hidden" value={item?.id} />
                    {item?.fields?.DropdownText?.value}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortingComponent;
